interface Campaign {
  skuPrefix: string;
  featuredImage: string;
  thumbnail: string;
}

declare global {
  interface Window {
    current_variant_sku?: string;
  }
}

const campaigns: Record<string, Campaign> = {
  DNA01: {
    skuPrefix: 'DNA',
    featuredImage:
      'https://res.cloudinary.com/embark/image/upload/f_auto,q_auto/v1690819071/shop.embarkvet.com/box_images/BH-W.jpg',
    thumbnail:
      'https://res.cloudinary.com/embark/image/upload/c_scale,w_464,f_auto,q_auto,dpr_2/v1690819071/shop.embarkvet.com/box_images/BH-W.jpg',
  },
  DNB01: {
    skuPrefix: 'DNB',
    featuredImage:
      'https://res.cloudinary.com/embark/image/upload/f_auto,q_auto/v1690819071/shop.embarkvet.com/box_images/BID-W.jpg',
    thumbnail:
      'https://res.cloudinary.com/embark/image/upload/c_scale,w_464,f_auto,q_auto,dpr_2/v1690819071/shop.embarkvet.com/box_images/BID-W.jpg',
  },
  DNP01: {
    skuPrefix: 'DNP',
    featuredImage:
      'https://res.cloudinary.com/embark/image/upload/f_auto,q_auto/v1690819071/shop.embarkvet.com/box_images/PB-W.jpg',
    thumbnail:
      'https://res.cloudinary.com/embark/image/upload/c_scale,w_464,f_auto,q_auto,dpr_2/v1690819071/shop.embarkvet.com/box_images/PB-W.jpg',
  },
  BND50101: {
    skuPrefix: 'BND501',
    featuredImage:
      'https://res.cloudinary.com/embark/image/upload/f_auto,q_auto/v1690819071/shop.embarkvet.com/box_images/MB-2pack.jpg',
    thumbnail:
      'https://res.cloudinary.com/embark/image/upload/c_scale,w_464,f_auto,q_auto,dpr_2/v1690819071/shop.embarkvet.com/box_images/MB-2pack.jpg',
  },
  BND50301: {
    skuPrefix: 'BND503',
    featuredImage:
      'https://res.cloudinary.com/embark/image/upload/f_auto,q_auto/v1690819071/shop.embarkvet.com/box_images/PB-2pack.jpg',
    thumbnail:
      'https://res.cloudinary.com/embark/image/upload/c_scale,w_464,f_auto,q_auto,dpr_2/v1690819071/shop.embarkvet.com/box_images/PB-2pack.jpg',
  },
};

const isGoogleShoppingCampaign = (): boolean => {
  const url = new URL(window.location.href);

  if (!url.searchParams.has('g_campaign')) {
    return false;
  }

  if (url.searchParams.get('g_campaign')?.toLowerCase().includes('_pmax_')) {
    return true;
  }

  if (url.searchParams.get('g_campaign')?.toLowerCase().includes('_pla_')) {
    return true;
  }

  return false;
};

export function updateTheFeaturedImageBasedOnCampaign(campaign = ''): void {
  if (!campaign || !isGoogleShoppingCampaign()) {
    return;
  }

  if (!(campaign in campaigns)) {
    return;
  }

  const data = campaigns[campaign];

  const imageElements = document.querySelectorAll(
    `.media-variant-${data.skuPrefix} .product-single__photo img`
  );
  const thumbnailElement = document.querySelector(
    `.media-thumb-${data.skuPrefix} .product-single__thumbnail img`
  );

  if (!thumbnailElement) {
    return;
  }

  imageElements.forEach((imageElement) => {
    imageElement.setAttribute('src', data.featuredImage);
    imageElement.removeAttribute('srcset');
    imageElement.removeAttribute('data-srcset');
    imageElement.removeAttribute('data-src');
  });

  const zoomContainers = document.querySelectorAll(
    `.media-variant-${data.skuPrefix} .product-single__photo, .media-thumb-${data.skuPrefix} .product-single__thumbnail`
  );

  zoomContainers.forEach((zoomContainer) => {
    zoomContainer.setAttribute('data-zoom', data.featuredImage);
  });

  thumbnailElement.setAttribute('src', data.thumbnail);
}
